// 카카오 메시지 랜딩/링크 URL 스킴 검증(프론트 1차 방어). 백엔드 MessageUrlValidator.kt 와 규칙 동기화.
// 배경: 버튼 링크가 스킴("https://") 없이 저장되면 카카오 모먼트 소재 등록/친구톡 발송이 실패한다.
// 정책: 자동 보정(스킴 주입) 없음 — 스킴이 불완전하면 오류로 안내해 고객이 직접 수정하도록 한다.

// http:// 또는 https:// 로 시작하고 공백이 없는 완전한 절대 URL.
export const URL_SCHEME_REGEX = /^https?:\/\/\S+$/i;

// 값이 없으면 통과(선택 항목·발송 시 동적 생성분). 값이 있으면 스킴을 강제.
export const isValidMessageUrl = (url) => {
  if (url == null) return true;
  const trimmed = String(url).trim();
  if (trimmed === "") return true;
  return URL_SCHEME_REGEX.test(trimmed);
};

// messageData 전체를 훑어 스킴이 불완전한 URL 항목의 한글 오류 메시지 배열을 반환한다. 문제 없으면 [].
export const collectMessageUrlErrors = (messageData) => {
  if (!messageData) return [];
  const errors = [];
  const check = (url, label) => {
    if (!isValidMessageUrl(url)) {
      errors.push(`${label}는 http:// 또는 https:// 로 시작하는 완전한 주소여야 합니다. (입력값: "${url}")`);
    }
  };

  const checkButtons = (buttons, prefix) => {
    (buttons || []).forEach((b, i) => {
      // 웹링크 버튼만 URL 필수(백엔드와 동일). 프론트 버튼 타입은 WL/LINK 혼용 → 둘 다 포함.
      if (b?.type === "WL" || b?.type === "LINK") {
        check(b.urlMobile, `${prefix} 버튼[${i + 1}] 모바일 링크`);
        check(b.urlPc, `${prefix} 버튼[${i + 1}] PC 링크`);
      }
    });
  };
  const checkCoupon = (coupon, prefix) => {
    if (!coupon) return;
    check(coupon.urlMobile, `${prefix} 쿠폰 모바일 링크`);
    check(coupon.urlPc, `${prefix} 쿠폰 PC 링크`);
  };

  check(messageData.image?.imgLink, "이미지 클릭 링크");
  checkButtons(messageData.buttons, "메시지");
  checkCoupon(messageData.coupon, "메시지");

  (messageData.items || []).forEach((item, i) => {
    check(item.urlMobile, `리스트 아이템[${i + 1}] 모바일 링크`);
    check(item.urlPc, `리스트 아이템[${i + 1}] PC 링크`);
  });

  if (messageData.tail) {
    check(messageData.tail.urlMobile, "더보기 모바일 링크");
    check(messageData.tail.urlPc, "더보기 PC 링크");
  }

  if (messageData.video) check(messageData.video.videoUrl, "영상 URL");

  (messageData.carousels || []).forEach((c, i) => {
    const prefix = `캐러셀[${i + 1}]`;
    check(c.attachment?.image?.imgLink, `${prefix} 이미지 클릭 링크`);
    checkButtons(c.attachment?.buttons, prefix);
    checkCoupon(c.attachment?.coupon, prefix);
  });

  return errors;
};
